<template>
  <div>
    <div class="change-location">
      <ChangeLocation/>
    </div>
    <div class="email-login" v-loading="loading">
      <div class="email-login-container">
        <el-form>
          <el-form-item label="Email">
            <el-input v-model="email" placeholder="Введите email"/>
          </el-form-item>
          <el-form-item label="Пароль" v-if="view !== 'reset'">
            <el-input
              type="password"
              v-model="password"
              placeholder="Введите пароль"
            />
            <div class="reset-password">
              <span @click="$router.push('/registration')">Регистрация</span>

              <span @click="view = 'reset'">Восстановить пароль</span>
            </div>
          </el-form-item>
          <el-button type="primary" @click="signIn" v-if="view !== 'reset'">Вход</el-button>
          <el-button type="primary" @click="resetPassword" v-else>Востановить</el-button>
          <div>
            <el-button type="default" v-if="view === 'reset'" @click="view = null">Назад</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import ChangeLocation from "../../components/ChangeLocation";

export default {
  name: 'Login',
  components: {ChangeLocation},
  data() {
    return {
      email: '',
      password: '',
      error: null,
      view: null,
      loading: false,
      confirmPassword: '',
    };
  },
  mounted() {
    const token = sessionStorage.getItem('invite_token');
    const projectId = sessionStorage.getItem('invite_project');
    const block = sessionStorage.getItem('is_block');

    if (token && projectId && !block) {
      const path = firebase.firestore().collection('invites');
      sessionStorage.setItem('is_block', '1');
      path
        .where('hash', '==', token)
        .where('projectId', '==', projectId)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {

            const subDocData = subDoc.data();

            firebase.auth().fetchSignInMethodsForEmail(subDocData.email.toLowerCase().replace(/\s/g, '')).then((response) => {
              if (!response.includes('password')) {
                this.$router.push('registration');
              }
            })
          });
        })
    }
  },
  methods: {
    resetPassword() {
      this.loading = true;
      firebase.auth().sendPasswordResetEmail(this.email.toLowerCase().replace(/\s/g, '')).then(() => {
        const proxy = firebase.functions().httpsCallable('onSendEmailByResetPassword');
        proxy(
          {
            email: this.email.toLowerCase().replace(/\s/g, ''),
          },
        ).then(() => {
          this.view = null;
          this.loading = false;
          this.$notify.success({
            offset: 60,
            title: 'Успешно',
            message: 'Дальнейшая инструкция по восстановлению пароля отправлена вам на почту',
          });
        }).catch((error) => {
          this.$notify.error({
            title: 'Ошибка', offset: 60,
            message: error,
          });
          this.loading = false;
        });
      }).catch((error) => {
        this.$notify.error({
          title: 'Ошибка', offset: 60,
          message: error,
        });
        this.loading = false;
      });
    },
    signIn() {
      this.error = null;
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(String(this.email).toLowerCase().replace(/\s/g, ''), this.password)
        .then(() => {
          this.$router.push('/dashboard');
          this.loading = false;
        })
        .catch(error => {
          if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
            this.$notify.error({
              title: 'Ошибка', offset: 60,
              message: 'Пользователя с такими данными не существует',
            });
          } else if (error.code === 'auth/invalid-email') {
            this.$notify.error({
              title: 'Ошибка', offset: 60,
              message: 'Некорректный email',
            });

          } else {
            this.$notify.error({
              title: 'Ошибка', offset: 60,
              message: error,
            });

          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.email-login {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 60px;
}

.reset-password {
  display: flex;
  justify-content: space-between;
  margin-bottom: -18px;
  color: #409EFF;
  text-decoration: none;

  span {
    cursor: pointer;

    &:hover {
      color: #66b1ff;
    }
  }
}

.email-login-container {
  max-width: 382px;
  width: calc(100% - 40px);

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}

.change-location {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  right: 30px;
  margin-top: 30px;
  cursor: pointer;
  padding: 30px 20px;
  margin-bottom: -40px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/Authorization/Index.vue